// Quick-share the live link to the other parties via WhatsApp or email, with a
// pre-filled message. Plain anchors (no popups) so mailto and wa.me open reliably.
export function ShareButtons({
  url,
  title,
  emails,
  message,
  subject,
}: {
  url: string;
  title?: string;
  emails?: (string | undefined)[];
  /** Overrides the default "invited to review" wording — a letter is issued to
   * the Contractor, not put out for comment, so it reads as a transmittal. */
  message?: string;
  /** Email subject line; defaults to the contract-review wording. */
  subject?: string;
}) {
  const msg = message || `You're invited to review the contract${title ? ` "${title}"` : ""}. Open this link to view the document and add your comments:\n${url}`;
  const subj = subject || `Contract review${title ? ` — ${title}` : ""}`;
  const to = (emails || []).filter(Boolean).join(",");
  const wa = `https://wa.me/?text=${encodeURIComponent(msg)}`;
  const mail = `mailto:${to}?subject=${encodeURIComponent(subj)}&body=${encodeURIComponent(msg)}`;
  return (
    <>
      <a className="btnlink wa" href={wa} target="_blank" rel="noreferrer" title="Share via WhatsApp">
        <span className="wa-dot" /> WhatsApp
      </a>
      <a className="btnlink" href={mail} title="Share via email">✉ Email</a>
    </>
  );
}
